export default __webpack_public_path__ + "media/images/enlarge-47887b65b675147dc4ab5724a5d19b4f.svg";